const cartContainer = document.getElementById("Cart-Drawer");
let upsellTriggered = false;

if (!cartContainer) return;

cartContainer.addEventListener("click", function(e) {
  const button = e.target.closest("#checkoutFormMob");
  if (!button) return;
  validateAndProceed();
});



cartContainer.addEventListener("click", function(e) {
  const button = e.target.closest('product-recommendations .side-panel-close');
  if (!button) return;
  document.getElementById('cart-drawer--recommendations--container').style.display = 'none';
});




function validateAndProceed() {
  let termsCheckbox = document.getElementById('CartDrawerTerms');
  
  if (!termsCheckbox) return;
  if (termsCheckbox.checked) {
    showUpsell();    
    upsellTriggered = true;
  } else {
    let checkoutForm = document.getElementById('checkoutForm');
    if (!checkoutForm) return;
    checkoutForm.click();
  }

  function showUpsell() {
    let showCartUpsell = document.getElementById('cart-drawer--recommendations--container');
    if (!showCartUpsell) return;

    if(!document.querySelector('.recommended-product') || upsellTriggered) {
      document.querySelector('#showRecommendationsButton').click();
    } else {
      if(!upsellTriggered) {
        showCartUpsell.style.display = 'block';
        upsellTriggered = true;
      } else {
        showCartUpsell.style.display = 'none';
        upsellTriggered = true;
      }
      
    }


  }
}


